var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orders && _vm.orders.length > 0)?_c('div',[_c('div',{staticClass:"subtitle-2 my-3"},[_vm._v("Recent Orders")]),_vm._l((_vm.orders),function(item){return _c('Cell',{key:item._id,staticClass:"mb-3",attrs:{"order":item}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }